export const STORAGE_PREFIX = 'undefined';

export const TenantType = {
  ROOT: 1,
  AGENCY: 2,
};

export const TenantStatus = {
  ACTIVATED: 1,
  CLOSED: 2,
};

export const ITEMS_PER_PAGE = 10;

export const ImageType = {
  NORMAL: 'normal',
  PANO: 'pano',
  FLOORPLAN: 'floorplan',
};

export const ImageTypeNameMap = {
  [ImageType.NORMAL]: '2D',
  [ImageType.PANO]: '360°',
  [ImageType.FLOOR_PLAN]: 'Floor plan',
};

export const FloorPlanFileSource = {
  USER_UPLOAD: 'user_upload',
  CAD: 'cad',
  VIDEO: 'video',
};

export const FloorPlanFileSourceName = {
  [FloorPlanFileSource.USER_UPLOAD]: 'User uploads',
  [FloorPlanFileSource.VIDEO]: 'Video',
  [FloorPlanFileSource.CAD]: 'CAD',
};

export const FloorPlanStatus = {
  UPLOADING: 'uploading',
  NEEDS_INFORMATION: 'needs_information',
  CREATED: 'created',
  READY: 'ready',
  REFUNDED: 'refunded',
  FAILED: 'failed',
  EXTRA_COST_APPROVAL: 'extra_cost_approval',
  REQUEST_REFUND: 'request_refund',
  REQUEST_FILES: 'request_files',
  CHANGE_REQUESTED: 'change_requested',
  CONVERTING: 'converting',
};

export const FloorPlanPackage = {
  VIDEO: 'video',
  CAD: 'cad',
};

export const TransactionType = {
  TOP_UP: 'top_up',
  CONSUME_TO_UPLOAD_IMAGE: 'consume_to_upload_image',
  REFUND: 'refund',
  REFER_BONUS: 'refer_bonus',
  CONSUME_TO_REQUEST_CHANGES: 'consume_to_request_changes',
  ADMIN_CHARGE: 'admin_charge',
  CONSUME_TO_PURCHASE_PACKAGES: 'consume_to_purchase_packages',
  CONSUME_TO_PURCHASE_FLOOR_PLAN_EXTRA_CAMERA: 'consume_to_purchase_floor_plan_extra_camera',
  CONSUME_TO_PURCHASE_EXTRA_RENDER: 'consume_to_purchase_extra_render',
};

export const REFUNDABLE_TRANSACTION_TYPES = [
  TransactionType.CONSUME_TO_UPLOAD_IMAGE,
  TransactionType.CONSUME_TO_REQUEST_CHANGES,
  TransactionType.ADMIN_CHARGE,
  TransactionType.CONSUME_TO_PURCHASE_PACKAGES,
  TransactionType.CONSUME_TO_PURCHASE_FLOOR_PLAN_EXTRA_CAMERA,
  TransactionType.CONSUME_TO_PURCHASE_EXTRA_RENDER,
];
